import React from 'react';
import PropTypes from 'prop-types';
import { TextLineWrapper, TextLineLabel, TextLineContent } from './styled';

const TextLine = ({ label, value, className, style }) => {
  return (
    <TextLineWrapper className={className} style={style}>
      {label && <TextLineLabel htmlFor={label}>{label}</TextLineLabel>}
      <TextLineContent>{value || ''}</TextLineContent>
    </TextLineWrapper>
  );
};

TextLine.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
};

TextLine.defaultProps = {
  label: '',
  value: '',
  className: '',
  style: {},
};

export default TextLine;
